import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidates everything that renders reservations.
 *
 * Use after creating or cancelling reservations — including indirectly, such
 * as dedicating a desk, which cancels the bookings that were on it. Missing
 * these leaves the map and the agenda showing bookings the server has already
 * dropped.
 */
export const useInvalidateSchedules = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ["schedules"] }),
      queryClient.invalidateQueries({ queryKey: ["myAgenda"] }),
      queryClient.invalidateQueries({
        queryKey: ["organizations.schedulable"]
      }),
      queryClient.invalidateQueries({
        queryKey: ["organizations.questionnaire"]
      }),
      queryClient.invalidateQueries({ queryKey: ["tableOverview"] })
    ]);
  }, [queryClient]);
};
